export enum UserEvent {
  none = 0,
  joined = 1,
  left = 2,
  saved = 3,
}
